import './promo-block.scss';
import './promo-block.html.twig';

export default function () {
  // Get the mode based on the window size
  function getMode() {
    return window.innerWidth < 1440 ? 'mobile' : 'desktop';
  }
  // Calculate the required min-height based on the text block content
  function calculateHeight(textBlock) {
    const paddingOffset = 42;
    return `${textBlock.scrollHeight + paddingOffset}px`;
  }
  // Set initial window size
  const mode = getMode();

  const currentWidth = window.matchMedia('(min-width: 1024px)');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        const promo = entry.target.querySelector('.promo-block__container');
        if (entry.isIntersecting && currentWidth.matches) {
          promo.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    });

    const promoBlock = [...document.querySelectorAll('.promo-block')];
    promoBlock.forEach((container) => {
      observer.observe(container);
      if (container.querySelector('picture')) {
        const textBlock = container.querySelector('.promo-block__container');
        container.style.minHeight = calculateHeight(textBlock);
        window.addEventListener(
          'resize',
          function () {
            container.style.removeProperty('min-height');
            container.style.minHeight = calculateHeight(textBlock);
          },
          true
        );
      }
    });
  }

  // Add play/pause options to video
  const videos = document.querySelectorAll('.promo-block__video');
  videos.forEach((videoContainer) => {
    const play = videoContainer.querySelector('.promo-block__video__play');
    const video = videoContainer.querySelector('video');
    play.addEventListener('click', () => {
      play.classList.toggle('promo-block__video__play--paused');
      video.paused ? (play.ariaLabel = 'pause') : (play.ariaLabel = 'play');
      video.paused ? video.play() : video.pause();
    });
    if (mode === 'mobile') {
      video.pause();
      play.classList.toggle('promo-block__video__play--paused');
      video.paused ? (play.ariaLabel = 'pause') : (play.ariaLabel = 'play');
    }
  });
}
